<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :model="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-row>
		  
		    <el-col :span="6">
              <el-form-item label-width
                            prop="tid"
                            label="SKU">
                <el-input v-model="form.sku"></el-input>
              </el-form-item>
            </el-col>
			
			
            <el-col :span="6">
              <el-form-item label-width
                            prop="tid"
                            label="订单号">
                <el-input v-model="form.tid"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="oid"
                            label="子订单号">
                <el-input v-model="form.oid"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="role"
                            label="评价者角色">
                <el-input v-model="form.role"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="buyer_nick"
                            label="评价者昵称">
                <el-input v-model="form.buyer_nick"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label-width
                            prop="result"
                            label="评价结果">
                <el-input v-model="form.result"></el-input>
              </el-form-item>
            </el-col>
			
            <el-col :span="6">
              <el-form-item label-width
                            prop="point"
                            label="评价分数">
                   <number-range v-model="form.point" />
			
              </el-form-item>
            </el-col>
			
            <el-col :span="12">
              <el-form-item label-width
                            prop="create_time"
                            label="评价时间">
                <!-- <el-input v-model="form.create_time"></el-input> -->
                <el-date-picker v-model="form.create_time"
                                type="datetimerange"
                                :default-time="['00:00:00', '23:59:59']"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-show="searchAreaStatus">
            <el-col :span="6">
              <el-form-item label-width
                            prop="seller_nick"
                            label="被评价者昵称">
                <el-input v-model="form.seller_nick"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="product_title"
                            label="商品标题">
                <el-input v-model="form.product_title"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="price"
                            label="商品价格">
                <!-- <el-input v-model="form.price"></el-input> -->
                <number-range v-model="form.price" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="reply"
                            label="评价回复">
                <el-input v-model="form.reply"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="platform_from"
                            label="平台">
                <el-select clearable
                           v-model="form.platform_from"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in tradefrom"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="profession"
                            label="行业">
                <el-select clearable
                           v-model="form.profession"
                           placeholder="请选择"
                           style="width: 90%">
                  <el-option v-for="item in platlists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="business"
                            label="商家">
                <el-select v-loading="ptnListLoading"
                           clearable
                           v-model="form.business"
                           placeholder="请选择"
                           style="width: 90%">
                  <el-option v-for="item in ptnlists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="store"
                            label="店铺">
                <el-select v-loading="shopListLoading"
                           clearable
                           v-model="form.store"
                           placeholder="请选择"
                           style="width: 90%">
                  <el-option v-for="item in shoplists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithoutImport">
        <el-button @click="searchAreaStatus = !searchAreaStatus">{{searchAreaStatus ? "收起" : "展开" }}</el-button>
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
      <el-table-column prop="tid"
                       align="center"
                       header-align="center"
                       label="订单号"
                       width="160px"></el-table-column>
      <el-table-column prop="oid"
                       align="center"
                       header-align="center"
                       label="子订单号"
                       width="160px"></el-table-column>
					   
	<el-table-column prop="sku"
		   align="center"
		   header-align="center"
		   label="SKU"
		   width="220px"
		   show-overflow-tooltip></el-table-column>
					   
					   
      <el-table-column prop="product_title"
                       align="center"
                       header-align="center"
                       label="商品标题"
                       width="220px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="result"
                       align="center"
                       header-align="center"
                       label="评价结果"></el-table-column>
      <el-table-column prop="point"
                       align="center"
                       header-align="center"
                       label="评价分数"></el-table-column>
      <el-table-column prop="role"
                       align="center"
                       header-align="center"
                       label="评价者角色"></el-table-column>
      <el-table-column prop="buyer_nick"
                       align="center"
                       header-align="center"
                       label="评价者昵称"
                       width="120px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="评价时间"></el-table-column>
      <el-table-column prop="seller_nick"
                       align="center"
                       header-align="center"
                       label="被评价者昵称"></el-table-column>
      <el-table-column prop="content"
                       align="center"
                       header-align="center"
                       label="评价内容"
                       max-width="220px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="price"
                       align="center"
                       header-align="center"
                       label="商品价格"></el-table-column>
      <el-table-column prop="reply"
                       align="center"
                       header-align="center"
                       label="评价回复"
                       max-width="220px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="platform_from"
                       align="center"
                       header-align="center"
                       label="平台"
                       max-width="220px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="profession"
                       align="center"
                       header-align="center"
                       label="行业"></el-table-column>
      <el-table-column prop="business"
                       align="center"
                       header-align="center"
                       label="商家"></el-table-column>
      <el-table-column prop="store"
                       align="center"
                       header-align="center"
                       label="店铺"></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
import { getplatlists, getptnlists, getshoplists } from '@/common/mixins/select'
export default {
  mixins: [ActionLine, SearchMixin, getplatlists, getptnlists, getshoplists],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // async getTableData() {
    //   this.loading = true;
    //   let { data, err } = await this.axiosApi(
    //     Desc.list_api,
    //     this.queryPrdlists
    //   );
    //   this.loading = false;
    //   this.tableData = data.data.data.data;
    //   this.total = parseInt(data.data.data.total);
    //   dealReturn(data, err);
    // },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/base/comment/index.vue